const IP = process.env.NODE_ENV === 'production' ? 'https://api.snbc-connect.com/api' : 'https://api.snbc-connect.com/api';
// const IP = 'https://nomu.strategy-offsite-meeting.com/api';


export default IP;